import {useMutation} from "@tanstack/react-query";
import {toast} from "sonner";

import {TOAST_CONFIG} from "@/lib/constansts";
import {useInvalidate} from "@/src/modules/core/hooks";
import {captureParkingSubmitError} from "@/src/modules/core/lib/glitchtip/parking-capture";

import {dispatchLogsService} from "../services";
import {useTranslation} from "react-i18next";

type UseDispatchLogCreateParams = {
  onSuccess?: () => void;
};

export default function useDispatchLogCreate(params?: UseDispatchLogCreateParams) {
  const {t} = useTranslation("dispatch");
  const invalidateDispatchLogs = useInvalidate("dispatchlogs");
  const invalidateDispatchLog = useInvalidate("dispatchLog");

  return useMutation({
    mutationFn: (data: Record<string, unknown>) =>
      dispatchLogsService.createDispatchLog(data),
    retry: false,
    onSuccess: () => {
      invalidateDispatchLogs();
      invalidateDispatchLog();
      toast.success(t("toast.created"), TOAST_CONFIG);
      params?.onSuccess?.();
    },
    onError: (error) => {
      captureParkingSubmitError(error, {feature: "dispatchlogs", operation: "dispatch_log_create"});
    },
  });
}
